@import '../../themes/capsule.globals';

:host {
  display: block;
}

.icon {
  --height: 20px;
  --width: 20px;
}

.start-icon {
  transform: rotate(180deg);
}

.arrow-button {
  --button-secondary-icon-color: var(--cpsl-color-text-tertiary);
}
